import { useEffect, useState, useRef } from 'react';

export const useUnsavedFormChanges = <T extends Record<string, any>>(
	currentFormData: T,
	savedFormData: T
) => {
	const [isDirty, setIsDirty] = useState(false);
	const savedStateHashRef = useRef<string>('');

	useEffect(() => {
		savedStateHashRef.current = JSON.stringify(savedFormData);
	}, [savedFormData]);

	useEffect(() => {
		const currentHash = JSON.stringify(currentFormData);
		const savedHash = JSON.stringify(savedFormData);
		const hasChanges = currentHash !== savedHash;
		setIsDirty(hasChanges);
	}, [currentFormData, savedFormData]);

	const markAsClean = () => {
		savedStateHashRef.current = JSON.stringify(currentFormData);
		setIsDirty(false);
	};

	const resetToSaved = () => {
		savedStateHashRef.current = JSON.stringify(savedFormData);
		setIsDirty(false);
	};

	return {
		isDirty,
		markAsClean,
		resetToSaved,
	};
};
